export const BARCODE_MANAGEMENT = {
    BARCODE_TITLE: "barcode-title",
    BARCODE_SUBTITLE: "barcode-subtitle",
    BARCODE_MENU_OPTION: "menuOption",
    GENERATED_BY_NU_TOGGLE: "generated-by-nu-toggle",
    BARCODE_FIELD: "barcode-field",
    SAVE_BTN: "save-btn",
};
